import { Grid } from '@mui/material';
import Box from '@mui/material/Box';
import WsButton from 'stories/inputs/WsButton';
import WsFlexbox from 'stories/layout/WsFlexbox';

type Props = {
  isFirst: boolean;
  isLast: boolean;
  allDisabled?: boolean;
  nextDisabled?: boolean;
  handleBack: () => void;
  handleNext?: () => void;
  handleCancel: () => void;
};

export const StepperFooter = (props: Props) => {
  return (
    <Grid container item sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', p: 2 }}>
      <WsFlexbox padding={0} gap={1}>
        {!props.isFirst && (
          <WsButton
            label="Back"
            variant="outlined"
            onClick={props.handleBack}
            sx={{ mr: 1 }}
            disabled={props.allDisabled}
          />
        )}
        <Box sx={{ flexGrow: 1 }} />
        <WsButton
          label="Cancel"
          variant="outlined"
          color="warning"
          onClick={props.handleCancel}
          disabled={props.allDisabled}
        />
        <WsButton
          label={props.isLast ? 'Finish' : 'Next'}
          variant="contained"
          type={props.handleNext ? 'button' : 'submit'}
          onClick={props.handleNext}
          disabled={props.nextDisabled || props.allDisabled}
        />
      </WsFlexbox>
    </Grid>
  );
};

export default StepperFooter;
